import cx from 'classnames';
import { MDText } from 'i18n-react';

import { InfoFilledIcon } from '@motorway/motorway-storybook-cra';
import { Icon } from '@motorway/mw-highway-code/src/components/Icon/Icon';

import cypressIds from 'Components/cypress_ids.json';
import { IconTooltip } from 'Components/shared/IconTooltip';
import type { VehicleFeatures } from 'Pages/vehicles/helpers/vehicle.schema';
import { triggerFeaturesRetailValueTooltipHoverEvent } from 'Services/analytics/events';
import { formatText } from 'Utilities/formatters';
import { applyCypressData } from 'Utilities/helpers';

import vehicleFeaturesSectionTexts from '../VehicleFeaturesSection.texts';

import { FEATURES_RETAIL_VALUE_VARIANT } from './FeaturesRetailValue.const';

import styles from './FeaturesRetailValue.module.scss';

const LocalT = new MDText(vehicleFeaturesSectionTexts.retailValue);

interface FeaturesRetailValueProps {
	highValueCarFeatures: VehicleFeatures['highValueCarFeatures'];
	variant?: (typeof FEATURES_RETAIL_VALUE_VARIANT)[keyof typeof FEATURES_RETAIL_VALUE_VARIANT];
}

export const FeaturesRetailValue: React.FC<FeaturesRetailValueProps> = ({
	highValueCarFeatures,
	variant = FEATURES_RETAIL_VALUE_VARIANT.tooltip,
}) => {
	const formattedValue = `£${formatText(highValueCarFeatures.totalCost)}`;

	const isTooltipVariant = variant === FEATURES_RETAIL_VALUE_VARIANT.tooltip;

	return (
		<div className={cx(styles.contentContainer, { [styles.contentContainerWithoutMessage]: isTooltipVariant })}>
			<p className={styles.label}>{LocalT.translate('title')}</p>
			<div className={styles.valueContainer}>
				<p className={styles.value}>{formattedValue}</p>
				{isTooltipVariant && (
					<IconTooltip
						content={LocalT.translate('description')}
						onMouseEnter={triggerFeaturesRetailValueTooltipHoverEvent}
						side="bottom"
						triggerProps={{
							...applyCypressData(cypressIds.tooltips.featuresRetailValue),
							'aria-label': 'featuresRetailValueTooltip',
							role: 'tooltip',
						}}
					/>
				)}
			</div>
			{variant === FEATURES_RETAIL_VALUE_VARIANT.message && (
				<div className={styles.message}>
					<div className={styles.icon}>
						<Icon size="small">
							<InfoFilledIcon />
						</Icon>
					</div>
					<span className={styles.messageContent}>{LocalT.translate('description')}</span>
				</div>
			)}
		</div>
	);
};
